<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Purchasing</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalPurchasing | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Laporan Pembelian</h4>
                        <div class="form-inline">
                          <span><b>Company:</b></span>
                          <select v-model="company_no" class="form-control">
                            <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <span><b>Vendor:</b></span>
                          <v-select :options="selectVendor" :reduce="vendor => vendor.meta.code" label="vendor" v-model="vendor_no" class="vsc-custom vsc-custom-inline"/>
                          <span><b>Date:</b></span>
                          <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                          </button>
                          <!-- <button type="button" class="btn btn-sm btn-soft-primary" @click="processReport">Process</button> -->
                            <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" /> -->
                          <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-print" aria-hidden="true"></i> Print
                          </button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#purchasing" data-toggle="tab" aria-expanded="false" class="nav-link active">Purchasing</a></li>
                            <li class="nav-item"><a href="#raw" data-toggle="tab" aria-expanded="false" class="nav-link">Raw</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="purchasing">
                                <div v-for="i in filterData" :key="i.id">
                                    <h5 class="text-center text-light-green" style="margin-top: 20px"><b>{{ i.name }}</b></h5>
                                    <hr/>
                                    <div class="table-responsive">
                                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                                            <thead>
                                                <th>Product</th>
                                                <th>Qty</th>
                                                <th>Uom</th>
                                                <th class="text-right">Price</th>
                                                <th class="text-right">Discount</th>
                                                <th class="text-right">DPP</th>
                                                <th class="text-right">Tax</th>
                                                <th class="text-right">Total</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="a in i.group" :key="a.id">
                                                    <td><b>[{{ a.product_no}}]</b> {{ a.description }}</td>
                                                    <td>{{ a.qty }}</td>
                                                    <td>{{ a.uom_id }}</td>
                                                    <td class="text-right">{{ a.price | currency }}</td>
                                                    <td class="text-right">{{ a.discount | currency }}</td>
                                                    <td class="text-right">{{ a.subtotal | currency }}</td>
                                                    <td class="text-right">{{ a.tax | currency }}</td>
                                                    <td class="text-right">{{ a.total | currency }}</td>
                                                </tr>
                                                <tr>
                                                  <td colspan="6"></td>
                                                  <td>Total Purchasing:</td>
                                                  <td class="text-right"><b>{{ i.total_purchasing | currency }}</b></td>
                                                </tr>
                                                <tr>
                                                  <td colspan="6"></td>
                                                  <td>Total Delivery:</td>
                                                  <td class="text-right"><b>{{ i.total_delivery | currency }}</b></td>
                                                </tr>
                                                <tr>
                                                  <td colspan="6"></td>
                                                  <td>Total:</td>
                                                  <td class="text-right"><b>{{ i.total_purchasing + i.total_delivery | currency }}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="raw">
                                <div v-for="i in filterData" :key="i.id">
                                    <h5 class="text-center" style="margin-top: 20px"><b>{{ i.name }}</b></h5>
                                    <hr/>
                                    <div class="table-responsive">
                                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                                            <thead>
                                                <th>Date</th>
                                                <th>Purchasing No</th>
                                                <th>Product</th>
                                                <th>Qty</th>
                                                <th>Uom</th>
                                                <th class="text-right">Price</th>
                                                <th class="text-right">Discount</th>
                                                <th class="text-right">DPP</th>
                                                <th class="text-right">Tax</th>
                                                <th class="text-right">Total</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="a in i.purchasings" :key="a.id">
                                                    <td>{{ a.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                                                    <td>
                                                        <span class="text-ref-sales" @click="showPurchasingNo(a.purchasing_no)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">
                                                            {{ a.purchasing_no }}
                                                        </span>
                                                    </td>
                                                    <td><b>[{{ a.product_no}}]</b> {{ a.description }}</td>
                                                    <td>{{ a.qty }}</td>
                                                    <td>{{ a.uom_id }}</td>
                                                    <td class="text-right">{{ a.price | currency }}</td>
                                                    <td class="text-right">{{ a.discount | currency }}</td>
                                                    <td class="text-right">{{ a.subtotal | currency }}</td>
                                                    <td class="text-right">{{ a.tax | currency }}</td>
                                                    <td class="text-right">{{ a.total | currency }}</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td class="text-right"><b>{{ i.total_purchasing | currency }}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <PurchasingModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { reportTransactionUrl, purchasingUrl, purchasing2Url, getHeader } from '@/config'
import DatePicker from 'vue2-datepicker'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'

export default {
  name: 'PurchasingReportVendor',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    PurchasingModal
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getUrcFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      vendor_no: '',
      filterType: [],
      loadingSales: true,
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getVendorList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser,
      vendorList: state => state.vendors.vendorList
    }),
    totalPurchasing () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_purchasing) + parseFloat(array[i].total_delivery)
      }
      return sum
    },
    selectVendor () {
      var array = this.vendorList
      var loop = [{
        vendor: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          vendor: '[' + array[a].vendor_no + '] ' + array[a].name,
          meta: {
            code: array[a].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (this.filterType[i] === d.type) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    async uncheckReportPayment (id, refNo) {
      var array = this.selected
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === id) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: refNo
        }
        await axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        vendor_no: this.vendor_no
      }
      console.log(obj)
      console.log(purchasingUrl + '/report-purchasing-by-vendor')
      await axios.post(purchasingUrl + '/report-purchasing-by-vendor', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async processReport () {
      this.$Progress.start()
      this.loader.isLoading = true
      for (let c = 0; c < this.selected.length; c++) {
        var data = this.dataRaw.find(d => d.id === this.selected[c])
        var obj = {
          cash_id: data.id,
          company_no: data.company_no,
          report_date: data.cash_date
        }
        await axios.post(reportTransactionUrl + '/create-cash-on-hand', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(purchasing2Url + '/purchasing-by-vendor', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
.text-light-green {
    color: #28A745;
}
</style>
